/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var KeyCode = /** @class */ (function () {
    function KeyCode() {
    }
    KeyCode.BACKSPACE = 8;
    KeyCode.TAB = 9;
    KeyCode.ENTER = 13;
    KeyCode.SHIFT = 16;
    KeyCode.ESCAPE = 27;
    KeyCode.SPACE = 32;
    KeyCode.LEFT = 37;
    KeyCode.UP = 38;
    KeyCode.RIGHT = 39;
    KeyCode.DOWN = 40;
    KeyCode.DELETE = 46;
    KeyCode.A = 65;
    KeyCode.C = 67;
    KeyCode.V = 86;
    KeyCode.D = 68;
    KeyCode.Z = 90;
    KeyCode.Y = 89;
    KeyCode.F2 = 113;
    KeyCode.PAGE_UP = 33;
    KeyCode.PAGE_DOWN = 34;
    KeyCode.PAGE_HOME = 36;
    KeyCode.PAGE_END = 35;
    return KeyCode;
}());
export { KeyCode };
